import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILayout, layoutProperties } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { type ILayoutState } from './types';

export const RETRIEVE_ALL_LAYOUTS = 'retrieveObjectLayouts';
export const RETRIEVE_LAYOUTS = 'retrieveLayouts';

export const actions: ActionTree<ILayoutState, unknown> = {
    async [RETRIEVE_ALL_LAYOUTS](context): Promise<number[]> {
        const query = queryBuilder.build();
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties: layoutProperties.DEFAULT
        });
        return idList;
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILayout[] }) {
        dataObjectList.forEach((layout) => {
            const criteria: string[] = [];
            const orderedCriteria = layout.criteria.sort((a, b) => {
                return a.attribute.localeCompare(b.attribute);
            });
            orderedCriteria.forEach((criterion) => {
                criteria.push(`${criterion.attribute}-${criterion.values?.toString() ?? 'null'}`);
            });
            context.state.layoutByClassName.set(`${layout.forClassName}:${criteria.join(':')}`, layout.dobjId);
            context.state.dataObjectList.set(layout.dobjId, layout);
        });
    }
};
